import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Role, RoleState } from '@/modules/settings/roles/types/types.ts'

const initialState: RoleState = {
  selected: undefined,
  edit: undefined,
  isOpenModal: false
}

const roleSlice = createSlice({
  name: 'roles',
  initialState,
  reducers: {
    setSelected: (state, action: PayloadAction<Role | undefined>) => {
      state.selected = action.payload
    },
    setEdit: (state, action: PayloadAction<Role | undefined>) => {
      state.edit = action.payload
    },
    setOpenModal: (state, action: PayloadAction<boolean>) => {
      state.isOpenModal = action.payload
    }
  }
})

export const rolesActions = roleSlice.actions
export const { reducer: rolesReducer } = roleSlice
